import { Accordion } from '@mantine/core';
import { Info } from 'lucide-react';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';
import { cn } from '@/utils';

const AccordionInfo: FC = () => {
	const { isMiniCreatorMode, localization } = useHostContext();

	const textClass = cn('mb-2', { 'mt-0 mb-1 text-sm': isMiniCreatorMode });

	return (
		<Accordion
			className={cn(
				'w-full bg-white !pl-0 !pr-0 rounded-lg pb-[30px] !self-start flex flex-col flex-1 min-h-0',
				{
					'pb-0': isMiniCreatorMode
				}
			)}
			classNames={{
				content: cn({ 'pb-0': isMiniCreatorMode }),
				label: '!p-0',
				control: '!bg-transparent hover:!bg-transparent'
			}}
			defaultValue={['open']}
			key="accordion"
			multiple
		>
			<Accordion.Item
				className="rounded-xl !border-none flex flex-col flex-1 min-h-0"
				value="open"
			>
				<Accordion.Control>
					<div className="grid grid-cols-[18px_1fr] items-center gap-[8px]">
						<Info height="20px" />
						{localization.translate('common', 'read_more')}
					</div>
				</Accordion.Control>

				<Accordion.Panel className="flex-1 overflow-y-auto min-h-0">
					<h2 className={cn({ 'm-0 text-base': isMiniCreatorMode })}>
						{localization.translate(
							'creator',
							'agent_success.modal.accordion_content.heading'
						)}
					</h2>

					<p className={textClass}>
						{localization.translate(
							'creator',
							'agent_success.modal.accordion_content.intro'
						)}
					</p>

					<p className={cn('mb-4', { 'mb-1.5 text-sm': isMiniCreatorMode })}>
						{localization.translate(
							'creator',
							'agent_success.modal.accordion_content.call_instruction'
						)}
					</p>

					<p className={textClass}>
						{localization.rich(
							'creator',
							'agent_success.modal.accordion_content.important_test',
							{
								strong: (chunk) => <strong>{chunk}</strong>
							}
						)}
					</p>

					<p className={textClass}>
						{localization.translate(
							'creator',
							'agent_success.modal.accordion_content.conversation_hint'
						)}
					</p>

					<p className={textClass}>
						{localization.translate(
							'creator',
							'agent_success.modal.accordion_content.ai_newborn'
						)}
					</p>

					<p className={textClass}>
						{localization.rich(
							'creator',
							'agent_success.modal.accordion_content.next_steps',
							{
								strong: (chunk) => <strong>{chunk}</strong>
							}
						)}
					</p>

					<p className={textClass}>
						{localization.translate(
							'creator',
							'agent_success.modal.accordion_content.closing'
						)}
					</p>
				</Accordion.Panel>
			</Accordion.Item>
		</Accordion>
	);
};

export default AccordionInfo;
